// extracted by mini-css-extract-plugin
module.exports = {"expandCell":"translationMemoryDetail_expandCell__2LkYV","rowSelected":"translationMemoryDetail_rowSelected__1hcLc"};